<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import KitUpgradeInfoModal from "@/components/kit/upgrade/KitUpgradeInfoModal.vue";
import {useQuery} from "@tanstack/vue-query";
import {computed, ref} from "vue";
import axios from "axios";

const {data} = useQuery({
  queryKey: ['kit-upgrade-banner'],
  queryFn: async () => {
    const {data} = await axios.get('/ajax/v2/kit-upgrade-price')

    return data.data;
  }
});

const headerText = computed(() => {
  if (!data.value) {
    return '';
  }

  if (data.value.userType === 'SINGLE') {
    return 'Meet Kit — Your New SEO Expert';
  }

  return 'Meet Kit — Your New SEO Employee';
});

const bodyText = computed(() => {
  if (!data.value) {
    return '';
  }

  if (data.value.userType === 'SINGLE') {
    return 'Kit takes care of your SEO — from strategy to implementation — so you can focus on running your business.\n' +
      'Upgrade to get <strong>15% off for life.</strong>';
  }

  return 'Kit takes care of your client\'s SEO — from strategy to implementation — so you can focus on running your agency.\n' +
    'Upgrade to get <strong>15% off for life.</strong>';
})

const showInfoModal = ref(false);
</script>

<template>
  <div
    v-show="data?.showOffer"
    class="tailwind"
  >
    <div class="tw-w-full tw-bg-info-100 tw-border tw-border-info tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-4">
      <div class="tw-flex tw-items-stretch tw-self-stretch">
        <div class="tw-flex tw-items-center tw-justify-center tw-p-5 tw-bg-info tw-rounded-l-lg">
          <KitIcon />
        </div>
        <span
          id="triangle"
          class="tw-flex tw-h-auto tw-w-10 tw-bg-info"
        />
      </div>

      <div class="tw-flex tw-flex-col tw-gap-2">
        <span class="tw-font-bold tw-text-neutral-900 tw-text-base lg:tw-text-2xl">
          {{ headerText }}
        </span>
        <span
          class="tw-text-base lg:tw-text-xl tw-text-neutral-900"
          v-html="bodyText"
        />
      </div>

      <div class="tw-mr-6 tw-whitespace-nowrap">
        <DefaultButton
          variant="primary-inverted"
          @click="showInfoModal = true"
        >
          Upgrade Now
        </DefaultButton>
      </div>
    </div>
  </div>

  <KitUpgradeInfoModal
    v-if="showInfoModal"
    :user-type="data.userType"
    :currency="data.currency"
    :billing-period="data.billingPeriod"
    @close="showInfoModal = false"
  />
</template>

<style scoped>
#triangle {
  clip-path: polygon(0 0, 100% 0, 0 100%);
}
</style>
